<template>
  <div style="height: 100%">
    <div class="news-pc-body">
      <div class="body">
          <div class="title">{{news.title}}</div>
          <div class="content">
            <div class="left">
              <div class="group-title">{{news.title}}</div>
              <div class="group-item" v-for="(item) in news.list" :key="item.group" @click="onChooseGroup(item)">
                  <div :class="selectedGroup.group != item.group ? 'group-normal' : 'group-selected'">{{item.group}}</div>
              </div>
            </div>
            <div class="right">
              <div class="right-title">{{selectedGroup.group}}</div>
              <!-- <div class="news" v-for="(item) in selectedGroup.datalist" :key="item.time"> -->
              <div class="news" v-for="(item,index) in selectedGroup.datalist" :key="index">
                  <div class="time">{{item.time}}</div>
                  <div class="news-title">{{item.title}}</div>
                  <div class="news-subtitle">{{item.subTitle}}</div>
                  <div class="news-content" v-if="item.content">{{item.content}}<a v-if="item.linkurl" :href="item.linkurl">{{item.linkurl}}</a></div>
                  <img class="image" :src="'static/pic/' + item.image" v-if="item.image"/>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div class="news-mobile-body">
      <div class="header" @click="showMobileMenu()">{{selectedGroup.group}} <i class="el-icon-arrow-down" v-show="!isMobileMenuShow" /><i class="el-icon-arrow-up" v-show="isMobileMenuShow" /></div>
      <div v-if="isMobileMenuShow" class="header-menu">
        <div v-for="(item) in news.list" :key="item.group" @click="onChooseGroup(item)" class="header-menu-item">
          <div :class="selectedGroup.group != item.group ? 'group-normal' : 'group-selected'">{{item.group}}</div>
        </div>
      </div>
      <div class="mobile-body">
        <div class="title">{{news.title}}</div>
          <div class="content">
              <div class="news" v-for="(item,index) in selectedGroup.datalist" :key="index">
                  <div class="time">{{item.time}}</div>
                  <div class="news-title">{{item.title}}</div>
                  <div class="news-subtitle" v-if="item.subTitle">{{item.subTitle}}</div>
                  <div class="news-content" v-if="item.content">{{item.content}}<a v-if="item.linkurl" :href="item.linkurl">{{item.linkurl}}</a></div>
                  <img class="image" :src="'static/pic/' + item.image" v-if="item.image"/>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getCurLan} from '@/util/tools'
export default {
  name: 'news-page',
  data () {
    return {
      isMobileMenuShow: false,
      selectedGroup: [],
        news:
      {
          title: "新闻及进展",
          list: [
          {
              title: "我们研究组的工作“硅烯的发现和物性研究”，荣获北京市科技奖一等奖",
              subTitle: "",
              content: "获奖团队：吴克辉、陈岚、冯宝杰、程鹏、孟胜。",
              image: "",
              time: "2012.12月"
          }]
      },
    }
  },
  mounted () {
    var self = this
    getCurLan().then(res => {
      self.news = res.news
      self.selectedGroup = self.news.list[0]
    })
    // this.news = getCurLan().news;
    // this.selectedGroup = this.news.list[0]
  },
  methods: {
    onChooseGroup (item) {
      this.selectedGroup = item
      if (this.isMobileMenuShow) {
        this.isMobileMenuShow = false
      }
    },
    showMobileMenu () {
      this.isMobileMenuShow = !this.isMobileMenuShow
    }
  }
}
</script>
<style lang='scss' src='../assets/styles/pc/news-page.scss'></style>
<style lang='scss' src='../assets/styles/mobile/news-page.scss'></style>


// WEBPACK FOOTER //
// src/components/News.vue